import { css } from '@emotion/css';

export const disputeLabel = css`
  flex: 1 0 40% !important;
`;

export const editIcon = css`
  float: right;
  width: auto;
`;
